// extracted by mini-css-extract-plugin
module.exports = {"list":"list-1Bxvw_bM","img":"img-1B0oTfdA"};